<template>
  <div>
    <Section>
      <SectionHeader :title="$t('apps.settings.message.general')"/>
      <FormRow>
        <Col className="col-lg-6">
        <Label :text="`${$t('apps.settings.message.roletitle')} *`" />
        <BaseInput
          v-model="$v.input.title.$model"
          :classNames="[{ 'is-invalid': $v.input.title.$error }]"
          :disabled="disabled"
        />
        </Col>
      </FormRow>
    </Section>

    <Section>
      <SectionHeader :title="$t('apps.settings.message.setpermissions')"/>
      <FormRow>
        <Col className="col-lg-12">
        <BaseRolePermission
          :masterData="appRolePermissions"
          :data.sync="input.permissions"
        />
        </Col>
      </FormRow>
    </Section>

    <BaseFormAction
      :textCancel="$t('button.cancel')"
      :textSubmit="$t('button.save')"
      :isSubmitted="isSubmitted"
      @onCancel="handleCancel"
      @onSubmit="handleSubmit"
    />
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { cloneDeep } from 'lodash'

export default {
  props: {
    state: {
      type: Object,
      default: null,
    },
    isSubmitted: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    appRolePermissions: {
      type: Array,
      default: () => ([]),
    },
  },

  data () {
    return {
      input: {
        title: null,
        permissions: [],
      },
      inputOriginal: null,
    }
  },

  validations: {
    input: {
      title: {
        required,
      },
    },
  },

  watch: {
    input: {
      handler: function () {
        this.$emit('update:form', this.input)
      },
      deep: true,
    },
  },

  created () {
    if (this.state) {
      this.setInput(this.state)
    } else {
      this.inputOriginal = cloneDeep(this.input)
    }
  },

  methods: {
    handleCancel () {
      if (this.$listeners.onCancel) {
        this.$emit('onCancel')
      } else {
        this.input = cloneDeep(this.inputOriginal)
        this.scrollToTop(600)
      }
    },
    handleSubmit () {
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.scrollToTop(600)
      } else {
        this.$emit('onSubmit', this.input)
      }
    },
    setInput (state) {
      this.input.title = state.title
      this.input.permissions = cloneDeep(this.state.permissions)
      this.inputOriginal = cloneDeep(this.input)
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/combine/RolePermissionForm.vue